.footer {
    height: 30px;
    background: url(./assets/images/theme/footer_back.jpg) top right repeat-x;
    text-align: center;
}

.copyright {
    padding-top: 10px;
    font-size: 12px;
}
